var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('paystack',{staticClass:"btn blue",attrs:{"amount":_vm.amount,"email":_vm.email,"paystackkey":_vm.paystackkey,"reference":_vm.reference,"callback":_vm.callback,"close":_vm.close,"embed":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ae5f78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/testingPaystack.vue
// module id = null
// module chunks = 